import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import Country from "../../../Models/Catalogue/General/Country";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class CountryCatalogueEntry extends CatalogueEntry<Country> {

    constructor() {
        super("Countries", Country);
    }

    public get editRole() {
        return CatalogueRoles.Countries.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.countries;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveCountries;
    }
    
    public renderRow(item: Country, meta: Model.TransformMetaType<Country>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.countryCode} />
                <NeoGrid.Column bind={meta.countryName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}